import { component } from 'picoapp'
import { addItemByForm } from '@/lib/cart.js'
import Swiper, { Pagination } from 'swiper'

Swiper.use([Pagination])

export default component((node, ctx) => {
    let hasSelectedVariant = node.querySelector('[data-selectedvariant]').getAttribute('data-selectedvariant')

    const addToCart = document.querySelectorAll('.js-add-to-cart')
    const addToCartText = document.querySelectorAll('.product__addToCart--text')
    const form = node.querySelector('[data-form]')

    const { selectedOrFirstAvailableVariant, product } = JSON.parse(node.querySelector('.js-data').innerHTML)
    let currentVariant = product.variants.filter((v) => v.id === selectedOrFirstAvailableVariant)[0]

    const wrappingHandle = product.tags.find((tag) => tag.includes('wrapping_'))

    let headerElement = document.querySelector('.site-header__sticky')
    const stickyProductMeta = node.querySelector('.product__meta--flex')
    const sliderElem = node.querySelector('[data-slider]')
    const swiper = new Swiper(sliderElem, {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
        },
    })

    swiper.on('slideChange', function({ activeIndex, previousIndex, slides }) {
        const previousSlide = slides[previousIndex]
        const activeSlide = slides[activeIndex]

        const previousVideo = previousSlide.querySelector('video')
        const activeVideo = activeSlide.querySelector('video')

        previousVideo?.pause()
        activeVideo?.play()
    })

    const stickyAddToCart = document.querySelector('[data-sticky-add-to-cart]')

    stickyAddToCart.addEventListener('click', () => {
        form.dispatchEvent(new Event('submit'))
    })

    form.addEventListener('submit', (e) => {
        e.preventDefault()
        hasSelectedVariant = node.querySelector('[data-selectedvariant]').getAttribute('data-selectedvariant')
        if (hasSelectedVariant != '') {
            currentVariant = product.variants.filter((v) => v.id === parseInt(form.elements.id.value))[0]

            addToCart.forEach((ele) => {
                ele.classList.add('disabled')
            })

            addToCartText.forEach((ele) => {
                ele.innerHTML = theme.strings.addingToCart
            })

            if (wrappingHandle) {
                theme.cartItems = [...theme.cartItems, { id: product.id, wrappingHandle: wrappingHandle }]
            }

            addItemByForm(new FormData(e.currentTarget), function() {
                addToCart.forEach((ele) => {
                    ele.classList.remove('disabled')
                })
                addToCartText.forEach((ele) => {
                    ele.innerHTML = theme.strings.addToCart
                })
            })
        } else {
            ctx.emit('variant:openDrawer')
        }
    })

    function setStickyTopPosition(value) {
        const width = window.innerWidth
        if (width <= 900) {
            stickyProductMeta.style.top = `0px`
        } else {
            stickyProductMeta.style.top = `${ value }px`
        }
    }

    setStickyTopPosition(headerElement.clientHeight)

    window.addEventListener('resize', () => {
        setStickyTopPosition(headerElement.clientHeight)
    })

    const changeInventoryQuantity = (variant) => {
        const inventoryQuantityContainer = node.querySelector('.js-inventory-quantity')
        const inventoryAvailableElem = node.querySelector('.js-inventory-available')
        const inventoryNotifyElem = node.querySelector('.js-inventory-notify')
        const inventoryUnavailableElem = node.querySelector('.js-inventory-soldOut')

        const hasBis = inventoryQuantityContainer.dataset.bis === 'true'

        if (!inventoryQuantityContainer) return

        if (variant.available) {
            inventoryAvailableElem.hidden = false
            inventoryNotifyElem.hidden = true
            inventoryUnavailableElem.hidden = true
        } else {
            if (variant.create2stay) {
                inventoryAvailableElem.hidden = true
                inventoryNotifyElem.hidden = true
                inventoryUnavailableElem.hidden = false
            } else if (hasBis) {
                inventoryAvailableElem.hidden = true
                inventoryNotifyElem.hidden = false
                inventoryUnavailableElem.hidden = true
            } else {
                inventoryAvailableElem.hidden = true
                inventoryNotifyElem.hidden = true
                inventoryUnavailableElem.hidden = false
            }
        }
    }

    const initOptions = () => {
        const price = node.querySelector('.js-price')
        const compareAtPrice = node.querySelector('.js-compare-at-price')

        const callback = (variant) => {
            if (variant) {
                window.currentVariant = variant

                document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }))

                price.innerHTML = Shopify.formatMoney(variant.price, theme.moneyFormat)

                changeInventoryQuantity(variant)

                if (variant.compare_at_price > variant.price) {
                    compareAtPrice.innerHTML = Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat)
                }

                if (variant.available) {
                    addToCartText.forEach((ele) => {
                        ele.innerHTML = theme.strings.addToCart
                    })

                    addToCart.forEach((ele) => {
                        ele.classList.remove('product__button--addToCartInActive')
                        ele.classList.add('product__button--addToCartActive')
                        ele.disabled = false
                    })
                } else {
                    addToCartText.forEach((ele) => {
                        ele.innerHTML = theme.strings.soldOut
                    })

                    addToCart.forEach((ele) => {
                        ele.classList.remove('product__button--addToCartActive')
                        ele.classList.add('product__button--addToCartInActive')
                        ele.disabled = true
                    })
                }
            } else {
                addToCartText.forEach((ele) => {
                    ele.innerHTML = theme.strings.unavailable
                })

                addToCart.forEach((ele) => {
                    ele.classList.remove('product__button--addToCartActive')
                    ele.classList.add('product__button--addToCartInActive')
                    ele.disabled = true
                })
            }
        }

        const init = () =>
            new Shopify.OptionSelectors(`product-${ product.id }`, {
                product: product,
                onVariantSelected: callback,
                enableHistoryState: true,
            })

        init()
    }

    initOptions()

    let ticking = false
    const stickyCheckElement = node.querySelector('[data-addtocart]')
    const sticky = document.querySelector('.product__stickyAddToCart')
    doSomething(stickyCheckElement)
    function doSomething() {
        if (!isElementInViewport(stickyCheckElement)) {
            sticky.classList.add('product__stickyAddToCart--active')
        } else {
            sticky.classList.remove('product__stickyAddToCart--active')
        }
    }

    document.addEventListener('scroll', function(e) {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                doSomething()
                ticking = false
            })

            ticking = true
        }
    })

    function isElementInViewport(ele) {
        const rect = ele.getBoundingClientRect()
        return (
            rect.top >= 0 && rect.left >= 0 && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        )
    }

    const zoomContainer = node.querySelector('.product__zoom')
    const zoomCloseBtn = zoomContainer.querySelector('.product__zoom--close')
    const imageZoom = node.querySelector('[data-zoom-swiper]')
    let activeZoomVideo = null

    zoomCloseBtn.addEventListener('click', () => {
        zoomContainer.setAttribute('aria-hidden', true)

        activeZoomVideo?.pause()
    })

    const zoomSwiper = new Swiper(imageZoom, {
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    })

    zoomSwiper.on('slideChange', function({ activeIndex, previousIndex, slides }) {
        const previousSlide = slides[previousIndex]
        const activeSlide = slides[activeIndex]

        const previousVideo = previousSlide.querySelector('video')
        const activeVideo = activeSlide.querySelector('video')

        previousVideo?.pause()
        activeVideo?.play()

        activeZoomVideo = activeVideo
    })

    const desktopImageSlides = node.querySelectorAll('[data-index]')

    desktopImageSlides.forEach((slide) => {
        slide.addEventListener('click', () => {
            const index = slide.dataset.index
            zoomSwiper.slideTo(index, 0)
            zoomContainer.setAttribute('aria-hidden', false)
        })
    })

    const labelModalTriggers = node.querySelectorAll('[data-label]')
    const labelModals = document.querySelectorAll('[data-label-modal]')

    labelModals.forEach((modal) => {
        const closeBtn = modal.querySelector('.modal__close')
        const overlay = modal.querySelector('.modal__overlay')
        closeBtn.addEventListener('click', () => {
            modal.setAttribute('aria-hidden', true)
        })
        overlay.addEventListener('click', () => {
            modal.setAttribute('aria-hidden', true)
        })
    })

    labelModalTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            const modal = document.querySelector(`[data-label-modal="${ trigger.dataset.label }"]`)
            if (modal == null) return
            modal.setAttribute('aria-hidden', false)
        })
    })

    const initLoadHiddenImages = () => {
        const hiddenImages = node.querySelector('[data-hidden-images]')
        const trigger = node.querySelector('[data-load-hidden-images]')

        if (!trigger || !hiddenImages) return

        trigger.addEventListener('click', () => {
            hiddenImages.hidden = !hiddenImages.hidden

            trigger.children.forEach((child) => {
                child.hidden = !child.hidden
            })
        })
    }

    initLoadHiddenImages()
})
